<template>
  <div>
    <slot></slot>
  </div>
  
</template>

<script>
export default {
  mounted() {
     EventDispatcher.listen('checkBoxUpdated', () => {
       this.sendCheckBoxGroupFilterEvent();
    });
    this.sendCheckBoxGroupFilterEvent();
  },
  methods: {
    sendCheckBoxGroupFilterEvent() {
      let checkBoxGroup = [];
      for (let index = 0; index < this.$children.length; index++) {
        const child = this.$children[index];
        checkBoxGroup.push({ 'name': child.name, 'checked': child.checked });
      }
      EventDispatcher.fire('checkBoxGroupFiltersApplied', checkBoxGroup);
    }
  }
}
</script>

<style lang="scss" scoped>   

</style>